// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 594 ? "about" : chunkId) + "." + {"256":"c194232a","594":"bb6e21bc","605":"7a8896ac"}[chunkId] + ".js";
};